import { Field, Formik, FormikHelpers as FormikActions } from 'formik';
import React, { useEffect } from 'react';
import { Button } from '~/components/Button';
import {
    Form,
    FormColumn,
    FormControls,
    FormRow, InputField,
    IntentText,
    DateInputField,
    SelectField,
    FormTitle
} from '~/components/Form';
import { IModalComponent, IModalComponentClose } from '~/components/Modal';
import { Intent } from '~/lib/intent';
import { IBalance, BalanceSchema } from '~/modules/Clients/models/Finance';
import { getGranularityDateFormat } from '~/modules/Dashboard/lib/performance';
import { Granularity } from '~/modules/Dashboard/models/Performance';

import style from './index.module.scss';

interface IBalanceForm {
    sellerName?: string;
    paymentReleaseDate?: Date;
    balance?: IBalance;
    onSubmit?: (values: IBalance, formikActions: FormikActions<IBalance>, close: IModalComponentClose) => void;
}

export const BalanceForm: IModalComponent<IBalanceForm> = props => <Formik initialValues={{
    ...props.balance
}}
validationSchema={BalanceSchema}
onSubmit={(balance, actions) => props.onSubmit(balance, actions, props.close)}
>
    {formik => {
        const { status, isSubmitting, values, setFieldValue } = formik;

        useEffect(() => {
            if (values.actionType === 'add') {
                setFieldValue('expectedBalance', +values.currentBalance + +values.changeBalance);
            } else {
                setFieldValue('expectedBalance', +values.currentBalance - +values.changeBalance);
            }
        }, [values.actionType, values.changeBalance]);

        return <Form>
            <FormTitle>Change balance for {props.sellerName}</FormTitle>
            {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
            <FormRow noBorder>
                <FormColumn>
                    <Field name='currentBalance'
                        label='Current Balance($)'
                        options={{
                            disabled: true
                        }}
                        component={InputField}
                    />
                    <Field name='actionType'
                        label="Type"
                        options={{
                            disabled: isSubmitting,
                            items: [
                                {
                                    label: 'Add',
                                    value: 'add',
                                },
                                {
                                    label: 'Subtract',
                                    value: 'subtract',
                                }
                            ]
                        }}
                        component={SelectField}
                    />
                    <Field name='changeBalance'
                        label='Change Balance($)'
                        options={{
                            disabled: isSubmitting
                        }}
                        component={InputField}
                    />
                    <Field name='expectedBalance'
                        label="Expected balance($)"
                        options={{
                            disabled: true,
                        }}
                        component={InputField}
                    />
                    <Field name='revenuePeriod'
                        label='Revenue period'
                        options={{
                            allowSameDay: false,
                            placeholder: 'Revenue period',
                            disabled: isSubmitting,
                            formatOptions: getGranularityDateFormat(Granularity.DAILY)
                        }}
                        component={DateInputField}
                    />
                    <Field name='comment'
                        label='Comment'
                        options={{
                            disabled: isSubmitting
                        }}
                        component={InputField}
                    />
                    <IntentText intent={Intent.DANGER} className={style.errorFormMessage}>
                        * You cannot select a revenue period if payments for the selected dates have already been processed.
                    </IntentText>
                </FormColumn>
            </FormRow>



            <FormControls>
                <Button disabled={isSubmitting}
                    onClick={props.close}
                >Cancel</Button>
                <Button type='submit'
                    disabled={isSubmitting}
                    intent={Intent.PRIMARY}
                    rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin' />}
                >Save</Button>
            </FormControls>
        </Form>;
    }}
</Formik>;
